<template>
  <div>
    <p>redirecting...</p>
  </div>
</template>

<script>
export default {
  name: 'Callback',

  async created() {
    try {
      await this.$sso.exchangeToken(this.$route.query)

      const user = this.$sso.decodeUser()
      this.$store.set('sso/user', user)

      this.$router.push('/skane/event')
    } catch (error) {
      console.log(error)
      this.$router.push('/login')
    }
  }
}
</script>
